export default "__VITE_ASSET__CQBFv3rK__"